<div class="section u-margin-bottom-50 card-background-color border-color">
	<div class="athlete-data-container">
		<div class="image">
			<mat-icon *ngIf="!athleteData.athlete.photo">account_circle</mat-icon>
			<img *ngIf="athleteData.athlete.photo" [src]="athleteData.athlete.photo" class="photo" alt="athlete logo" />
		</div>
		<div class="info">
			<div class="big-name">
				{{ athleteData.athlete.first_name }} {{ athleteData.athlete.last_name }}
			</div>
			<div class="row test-col-name">
				<div class="col">TEST-ID</div>
				<div class="col">DATE</div>
				<div class="col">TYPE</div>
				<div class="col">SPORT</div>
				<div class="col">TAG</div>
			</div>
			<div class="row test-col-val">
				<div class="col">{{ athleteData.selectedTest.display_id }}</div>
				<div class="col">
					{{athleteData.selectedTest.test_date| dateFormatExt:
					constant.DATE_FORMAT.APP_FULL_DATE_MOMENT:false}}
				</div>
				<div class="col">
					{{ testService.formatTestType(athleteData.selectedTest.test_type) }}
				</div>
				<div class="col">{{ athleteData.selectedTest.sport.name }}</div>
				<div class="col">
					<span *ngFor="let tag of athleteData.selectedTest.tags">{{ tag.name }}</span>
				</div>
			</div>
		</div>
		<div class="sponsor">
			<img [src]="athleteData.orgPhotoSrc" *ngIf="athleteData.orgPhotoSrc" class="org-logo" alt="org logo" />
		</div>
	</div>
</div>